import request from '@/utils/request'

export const quizsGet = (options = {}) => request({
    url: '/quiz_apis/quizs',
    method: 'get',
    ...options
})

export const quizResultsPost = (options = {}) => request({
    url: '/quiz_apis/quiz_results',
    method: 'post',
    ...options
})

export const quizResultResultIdGet = (options = {}) => request({
    url: '/quiz_apis/quiz_result/{resultId}',
    method: 'get',
    ...options
})

export const quizResultResultIdPut = (options = {}) => request({
    url: '/quiz_apis/quiz_result/{resultId}',
    method: 'put',
    ...options
})

export const quizResultCheckPost = (options = {}) => request({
    url: '/quiz_apis/quiz_result/check',
    method: 'post',
    ...options
})

export const resultResultIdHelpGet = (options = {}) => request({
    url: '/quiz_apis/result/{resultId}/help',
    method: 'get',
    ...options
})
